import { useTranslation } from "react-i18next";

import * as Style from "./Styles";
import { Tooltip, Typography } from "@mui/material";
import { imgs } from "../../../constants/images";
import { numberFormat } from "../../../utils/common";
import Cloudupload from "../../../assets/icon/cloudupload";
import PreviewImage from "../../../component/image/PreviewImage";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import DepositApi from "../../../api/stall/deposit/deposit.api";

interface PopupPaymentProps {
  open?: boolean;
  amount?: string;
  time?: string;
  image?: string;
  qrCode?: string
  onClose?: () => void;
  onUploadBill?: (img: any) => void;
  onsubmit?: () => void
  getRootProps: any
  getInputProps: any
  detail?: any;

  // deposit-details
  is_deposit?: boolean;
}

export default function PopupPaymentStall(props: PopupPaymentProps) {
  const { t } = useTranslation();
  const cardRef = useRef<HTMLElement>(null);

  const [deposit_details, set_deposit_details] = useState<any[]>([]);

  const totalElectricity = props?.detail?.invoiceDetail?.filter((item: any) => item.paymentServiceId === 1)
    .map((item: any) => item.amount ? parseFloat(item.amount) : 0)
    .reduce((acc: any, value: any) => acc + value, 0);

  const totalWater = props?.detail?.invoiceDetail?.filter((item: any) => item.paymentServiceId === 2)
    .map((item: any) => item.amount ? parseFloat(item.amount) : 0)
    .reduce((acc: any, value: any) => acc + value, 0);

  const totalMulct = props?.detail?.invoiceDetail?.filter((item: any) => item.paymentServiceId === 5)
    .map((item: any) => item.amount ? parseFloat(item.amount) : 0)
    .reduce((acc: any, value: any) => acc + value, 0);

  const prepareURL = async () => {
    const cardElement = cardRef.current;
    if (!cardElement) return;
    try {
      const html2canvas = await import(
        "html2canvas"
      );

      const result = await html2canvas.default(cardElement);

      const asURL = result.toDataURL("image/jpeg");

      const anchor = document.createElement("a");
      anchor.href = asURL;
      anchor.download = `Qrcode_${props.detail?.stall?.stallNumber ? props.detail?.stall?.stallNumber.replace("/", '-') : ''}_${props.detail?.stall?.stallNumber ? moment().format('D-MM-YYYY') : moment().format('D-MM-YYYY_hh-mm-ss')}.jpeg`;
      anchor.click();
      anchor.remove();
    } catch (reason) {
      console.log(reason);
    }
  };



  // get one detail deposit
  const handleGetDepositDetail = async (depositId: number) => {
    await DepositApi.getOneDetail(depositId).then((res) => {
      if (res.status < 300) {
        const resposne = res.data;
        set_deposit_details(resposne ?? []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  useEffect(() => {
    if (props?.detail?.depositId && props.is_deposit) {
      handleGetDepositDetail(props?.detail?.depositId);
    }
  }, [props?.detail])

  return (
    <>
      <Style.BoxUploadImgContainer>
        <Style.ContainerUpload>
          <Style.ContainerBoxUpload>
            <Style.BoxUpload {...props.getRootProps}>

              <input {...props.getInputProps} />
              {props.image ? (

                <PreviewImage imageFile={props.image} />
              ) : (
                <div className="d-flex justify-content-center flex-column align-item-center">
                  <Cloudupload />
                  <div>แนบไฟล์ภาพ</div>
                </div>

              )}

            </Style.BoxUpload>
          </Style.ContainerBoxUpload>


          {props.is_deposit && deposit_details?.length > 0 && (
            <div className="px-2 px-md-3">
              {deposit_details?.map((list) => {
                return (
                  <Row key={list?.depositDetailId}>
                    <Col xs={12} md={3} lg={6} >
                      <Tooltip arrow title={list?.paymentName ?? list?.paymentNameEn ?? "-"}>
                        <Style.SubDetail lineClamp={2}>{list?.paymentName ?? list?.paymentNameEn ?? "-"}</Style.SubDetail>
                      </Tooltip>
                    </Col>
                    <Col xs={10} md={2} lg={3}>
                      <Style.SubDetail sx={{ textAlign: "end" }}>{numberFormat(list?.amount || 0)}</Style.SubDetail>
                    </Col>
                    <Col xs={2} md={3} lg={2}>
                      <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                    </Col>
                  </Row>
                )
              })}
            </div>
          )}

          <div>
            {!props.is_deposit && (
              <>
                <Row className="my-2">
                  <Style.SubDetail>{t("PAYBILL.REPORT.PAYMENT_DETAILS")}</Style.SubDetail>
                </Row>

                <Row>
                  <Col lg={3} md={2} />
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.ELECTRICITY_ฺBILL")}</Style.SubDetail>
                  </Col>
                  <Col lg={2} xs={4} md={3}>
                    <Style.SubDetail>{numberFormat(totalElectricity || 0)}</Style.SubDetail>
                  </Col>
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                  </Col>
                </Row>

                <Row>
                  <Col lg={3} md={2} />
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.WATER_BILL")}</Style.SubDetail>
                  </Col>
                  <Col lg={2} xs={4} md={3}>
                    <Style.SubDetail>{numberFormat(totalWater || 0)}</Style.SubDetail>
                  </Col>
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                  </Col>
                </Row>

                <Row>
                  <Col lg={3} md={2} />
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.STALL_BILL")}</Style.SubDetail>
                  </Col>
                  <Col lg={2} xs={4} md={3}>
                    <Style.SubDetail>{numberFormat(props?.detail?.invoiceDetail?.filter((d: any) => d.paymentServiceId === 3)?.map((value: any) => value.amount) || 0)}</Style.SubDetail>
                  </Col>
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} md={2} />
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("ค่าปรับ")}</Style.SubDetail>
                  </Col>
                  <Col lg={2} xs={4} md={3}>
                    <Style.SubDetail>{numberFormat(totalMulct || 0)}</Style.SubDetail>
                  </Col>
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                  </Col>
                </Row>
                <Row>
                  <Col lg={3} md={2} />
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.CREATE.OTHER_PAYMENT")}</Style.SubDetail>
                  </Col>
                  <Col lg={2} xs={4} md={3}>
                    <Style.SubDetail>{t("-")}</Style.SubDetail>
                  </Col>
                  <Col lg={3} xs={4} md={3}>
                    <Style.SubDetail>{t("PAYBILL.REPORT.BAHT")}</Style.SubDetail>
                  </Col>
                </Row>
              </>
            )}

            {props?.detail?.invoiceDetailDiscount?.length === 0 &&
              <Style.TextBoxUpload>
                <Typography>{t('PAYBILL.REPORT.DISCOUNT')}</Typography>
                <Typography>{t("-")}</Typography>
                <Typography>{t("PAYBILL.REPORT.BAHT")}</Typography>
              </Style.TextBoxUpload>
            }

            {props?.detail?.invoiceDetailDiscount?.filter((value: any) => value.paymentServiceId === 1)?.map((d: any, i: number) => {
              return (
                <div>
                  <Style.TextBoxUpload>
                    <Typography>{t('PAYBILL.REPORT.DISCOUNT_ELECTRICT')}</Typography>
                    <Typography>{d?.amount || 0}</Typography>
                    <Typography>{t("PAYBILL.REPORT.BAHT")}</Typography>
                  </Style.TextBoxUpload>
                </div>
              )
            })}

            {props?.detail?.invoiceDetailDiscount?.filter((value: any) => value.paymentServiceId === 3)?.map((d: any, i: number) => {
              return (
                <div>
                  <Style.TextBoxUpload>
                    <Typography>{t('PAYBILL.REPORT.DISCOUNT_STALL')}</Typography>
                    <Typography>{d?.amount || 0}</Typography>
                    <Typography>{t("PAYBILL.REPORT.BAHT")}</Typography>
                  </Style.TextBoxUpload>
                </div>
              )
            })}

            {props?.detail?.invoiceDetailDiscount?.filter((value: any) => value.paymentServiceId === 2)?.map((d: any, i: number) => {
              return (
                <div>
                  <Style.TextBoxUpload>
                    <Typography>{t('PAYBILL.REPORT.DISCOUNT_WATER')}</Typography>
                    <Typography>{d?.amount || 0}</Typography>
                    <Typography>{t("PAYBILL.REPORT.BAHT")}</Typography>
                  </Style.TextBoxUpload>
                </div>
              )
            })}
          </div>

          <Style.TextBoxUpload>
            <Typography>{t("STALL.POPUP.TRANSFORM_AMOUNT")}</Typography>
            <Typography>{numberFormat(props.amount || 0)}</Typography>
            <Typography>{t("STALL.POPUP.BATH_UNIT")}</Typography>
          </Style.TextBoxUpload>
          <Style.TextBoxAlert>
            <Typography>{t("STALL.POPUP.PAYMENT_DATE")}{" "}{props.time}</Typography>
          </Style.TextBoxAlert>
        </Style.ContainerUpload>

        {
          props.amount && props.amount !== "0" ? (
            <Style.ContainerQR>
              <Style.ThaiQR ref={cardRef}>
                <img src={imgs.thai_qr} />
                <Style.ImageQR src={props.qrCode} alt="" />
                <Style.TextQR className="w-100 d-flex justify-content-center mb-2">องค์การตลาดเพื่อเกษตรกร</Style.TextQR>
                {/* <Style.TextQR className="w-100 d-flex justify-content-center mb-2">099400016552800</Style.TextQR> */}
              </Style.ThaiQR>
              {/* <Style.ButtonDowload href={dowloadRef.current} download={dowloadRef.current} >ดาวน์โหลด</Style.ButtonDowload> */}
              <Style.ButtonDowload onClick={prepareURL}>ดาวน์โหลดQr code</Style.ButtonDowload>
            </Style.ContainerQR>
          ) : null
        }


      </Style.BoxUploadImgContainer>

      <Style.ButtonSubmit onClick={props.onsubmit}>บันทึก</Style.ButtonSubmit>
    </>
  );
}
